import { Elements } from "@stripe/react-stripe-js";
import { PropsWithChildren, ReactElement } from "react";
import { ElementsOptions } from "./constants";
import { useLoadStripe } from "./hooks";
import ErrorMessage from "@common/components/text/ErrorMessage";
import { Loader } from "@mantine/core";

export default function StripeProvider({
  children,
}: PropsWithChildren): ReactElement {
  // load stripe
  const { loading, stripe } = useLoadStripe(process.env.NEXT_PUBLIC_STRIPE_KEY);

  // loading
  if (loading) {
    return <Loader size="xs" />;
  }
  // error
  else if (!loading && !stripe) {
    return (
      <ErrorMessage
        error={
          <>
            An error occured when trying to load the payment form.
            <br />
            Please check your connection or browser extensions.
          </>
        }
      />
    );
  }

  // success
  return (
    <Elements options={ElementsOptions} stripe={stripe}>
      {children}
    </Elements>
  );
}
